import type { PropsWithChildren } from 'react';

import { SWRConfig } from 'swr';

const SWRProvider = ({ children }: PropsWithChildren) => (
  <SWRConfig
    value={{
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      onError: (error, key, config) => {
        console.error(error, key, config);
      },
    }}
  >
    {children}
  </SWRConfig>
);

export default SWRProvider;
